import React, { Component } from "react"
import Draggable from "react-draggable"
import Left from "./left"
import Right from "./right"
import { StaticQuery, graphql } from "gatsby"
import Header from "./header"
import Nav from "./nav"
import classNames from 'classnames'
import throttle from 'lodash/throttle'

function round(value, decimals) {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals)
}

class Split extends Component {
  constructor(props) {
    super(props)

    this.state = {
      width: 0.5,
      active: null,
      toggle: false, // on mobile, toggle true/false rather than % width
    }
    this.splitter = React.createRef()
  }

  eventLogger = (e = MouseEvent, data = Object) => {
    console.log("Event: ", e)
    console.log("Data: ", data)
  }

  handleDrag = (e = MouseEvent, data = Object) => {
    const intFrameWidth = window.innerWidth
    const ratio = e.pageX / intFrameWidth

    const width = this.minMax(ratio)

    if (e.pageX !== 0) {
      this.setState({
        width,
        toggle: (width < 0.5),
      })
    }
  }

  minMax(ratio) {
    return Math.min(Math.max(round(ratio, 3), 0.2), 0.8)
  }

  handleToggle = () => {
    this.setState({
      toggle: !this.state.toggle,
    })
  }

  setActive = active => {
    this.setState({ active })
  }

  render() {
    const width = {
      left: this.state.width * 100,
      right: 100 - this.state.width * 100,
    }

    const fontSize = {
      left: this.state.width * 2,
      right: (1 - this.state.width) * 2,
    }

    const size = {
      right: classNames({
        'small': width.right < 40,
        'regular': width.right >= 40 && width.right <= 66,
        'large': width.right > 66
      }),
      left: classNames({
        'small': width.left < 40,
        'regular': width.left >= 40 && width.left <= 66,
        'large': width.left > 66
      })
    }

    return (
      <div className={classNames('split-wrap', `split-wrap--active-${this.state.active}`)}>
        <Nav setActive={this.setActive} active={this.state.active} small={width.left < 40} />
        <Draggable
          axis="none"
          handle=".split-splitter__handle"
          onDrag={throttle(this.handleDrag, 75)}
          bounds="parent"
        >
          <div
            className="split-splitter"
            style={{ left: `calc(${width.left}vw - 0.875rem)` }}
            ref={this.splitter}
          >
            <div className="split-splitter__handle" />
          </div>
        </Draggable>
        <button className={classNames("split-toggle", {
          'split-toggle--open': this.state.toggle,
          'split-toggle--close': !this.state.toggle,
        })} onClick={this.handleToggle} />
        <div className={classNames('split', `split--active-${this.state.active}`, {
          'split--open': this.state.toggle,
          'split--close': !this.state.toggle,
        })}>
          <div className={classNames("split__panel split__panel--left", size.left)}>
            <div
              className="split__container"
              style={{
                width: `${width.left}vw`,
                fontSize: `${fontSize.left}rem`,
              }}
            >
              <Left {...this.props} active={this.state.active} setActive={this.setActive} />
            </div>
          </div>
          <div
            className={classNames("split__panel split__panel--right", size.right)}
            style={{
              width: `${width.right}vw`,
              fontSize: `${fontSize.right}rem`,
            }}
          >
            <StaticQuery
              query={graphql`
                query SiteTitleQuery {
                  site {
                    siteMetadata {
                      title
                    }
                  }
                }
              `}
              render={data => (
                <Header
                  siteTitle={data.site.siteMetadata.title}
                  left={`${width.left}vw`}
                />
              )}
            />
            <div className="split__container">
              <Right active={this.state.active} size={size.right} />
            </div>
          </div>
        </div>
        <style>{`
          :root {
            --width-left: ${width.left}vw;
            --width-right: ${width.right}vw;
          }
        `}</style>
      </div>
    )
  }
}

export default Split
